import React from 'react'
import './style.css'
const DeleteAccount = () => {
  return (
    <div>
      <div className='profile_justify'>
<div className='profile_black5'>
<div className='top_profile'>
               <div className='insti-profile'>
                    <h1 className='profile_profile'>Delete Account</h1>
                    <p className='del-para'>Pellentesque conubia natoque id mollis quis vitae elementum rhoncus leo vivamus vestibulum. Elit fusce lorem nam amet. Tincidunt accumsan nostra massa malesuada. </p>
                   <button className='profile_btn2'>Delete</button>
                    </div>
</div>
</div>
</div>
    </div>
  )
}

export default DeleteAccount
